module.exports = __webpack_public_path__ + "static/media/img-1.ee459702.jpg";